
const validate = (values) => {
  const errors = {};
  if (!values.clearingHouseName) {
    errors.clearingHouseName = 'Please enter clearing house name';
  }
  if (!values.senderID) {
    errors.senderID = 'Please enter sender id';
  }
  if (!values.receiverID) {
    errors.receiverID = 'Please enter receiver id';
  }
  if (!values.interchangeQualifier) {
    errors.interchangeQualifier = 'Please enter interchange qualifier';
  }
  if (!values.ftpurl) {
    errors.ftpurl = 'Please enter ftp url';
  }
  if (!values.portNo) {
    errors.portNo = 'Please enter ftp port';
  }
  if (!values.path837) {
    errors.path837 = 'Please enter path for 837 folder';
  }
  if (!values.path835) {
    errors.path835 = 'Please enter path for 835 folder';
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/clearing-house/validate.js